
import React from 'react';
import { Link } from 'react-router-dom';

const CloudVendorSolutions: React.FC = () => {
  return (
    <>
      <h2 className="text-2xl font-bold mb-4 mt-8 text-itmgmt-dark-blue">HIPAA-Compliant Cloud and Vendor Solutions</h2>
      <p className="mb-4 text-gray-700 leading-relaxed">
        Many healthcare providers now use third-party solutions and cloud services to manage ePHI. Here's what you need to know. For more information on secure cloud implementation, check our <Link to="/services/cloud-solutions" className="text-itmgmt-bright-blue hover:underline">cloud solutions</Link> page.
      </p>

      <h3 className="text-xl font-semibold mb-3 mt-6 text-itmgmt-medium-blue">Business Associate Agreements (BAAs)</h3>
      <p className="mb-4 text-gray-700 leading-relaxed">
        Any vendor with access to your ePHI must sign a Business Associate Agreement that legally obligates them to maintain HIPAA compliance. This is an essential part of <Link to="/blog/zero-trust-security-small-businesses" className="text-itmgmt-bright-blue hover:underline">zero trust security implementation</Link>.
      </p>
      <div className="mb-6 pl-5 border-l-4 border-itmgmt-light-blue">
        <p className="italic text-gray-700">
          <strong>Critical note:</strong> Without a proper BAA, you can be held liable for a business associate's HIPAA violations. Never assume a vendor is HIPAA-compliant without verification and a signed BAA.
        </p>
      </div>

      <h3 className="text-xl font-semibold mb-3 mt-6 text-itmgmt-medium-blue">Cloud Services Evaluation</h3>
      <p className="mb-4 text-gray-700 leading-relaxed">
        When selecting cloud services for healthcare data, ensure they meet these requirements. For personalized guidance, <Link to="/contact" className="text-itmgmt-bright-blue hover:underline">contact our team</Link> of healthcare IT specialists.
      </p>
      <ul className="list-disc ml-6 mb-6 text-gray-700 leading-relaxed">
        <li className="mb-2">Willingness to sign a BAA (many consumer-grade services won't)</li>
        <li className="mb-2">End-to-end encryption capabilities</li>
        <li className="mb-2">Data center locations (preferably within the U.S. for U.S. healthcare providers)</li>
        <li className="mb-2">Access control features that meet HIPAA requirements</li>
        <li className="mb-2">Audit logging capabilities</li>
        <li className="mb-2">Data integrity verification mechanisms</li>
      </ul>
    </>
  );
};

export default CloudVendorSolutions;
